export default "__VITE_ASSET__CFDOTqIz__"